import { render, staticRenderFns } from "./ProposalProductsRouterView.vue?vue&type=template&id=5ba0eeb4&"
import script from "./ProposalProductsRouterView.vue?vue&type=script&lang=js&"
export * from "./ProposalProductsRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports